import { supabase } from './supabase';
import { parseNetworkCustomers, type NetworkCustomer } from './networkCrm';

/**
 * CRM réseau (brique B) — lecture Supabase via RPC sécurisée `list_network_customers`
 * (super_admin only, cf. sql/23_network_crm.sql). La RPC renvoie la liste déjà assemblée
 * en JSON (customers + customer_tenants + tenants). Logique pure dans networkCrm.ts.
 */

export interface LoadNetworkResult {
  ok: boolean;
  customers: NetworkCustomer[];
  error?: string;
}

/** Charge la base clients réseau (clients finaux agrégés tous restos). */
export async function loadNetworkCustomers(): Promise<LoadNetworkResult> {
  const { data, error } = await supabase.rpc('list_network_customers');
  if (error) {
    return { ok: false, customers: [], error: error.message };
  }
  return { ok: true, customers: parseNetworkCustomers(data) };
}

export interface DeleteCustomersResult {
  ok: boolean;
  deleted: number;
  error?: string;
}

/**
 * Supprime des clients du CRM réseau via la RPC sécurisée `admin_delete_customers`
 * (super_admin only, cf. sql/35_delete_network_customer.sql). Renvoie le nombre supprimé.
 */
export async function deleteNetworkCustomers(ids: string[]): Promise<DeleteCustomersResult> {
  if (ids.length === 0) return { ok: true, deleted: 0 };
  const { data, error } = await supabase.rpc('admin_delete_customers', { p_ids: ids });
  if (error) {
    return { ok: false, deleted: 0, error: error.message };
  }
  return { ok: true, deleted: typeof data === 'number' ? data : ids.length };
}
